import React, { useState } from "react";
import type { Casting, Gender } from "@/types";
import { Button, RadioButton, Select } from "@/components/atoms";
import { CastingCard } from "@/components/molecules";
import "./CastingList.scss";
import { isAfter, endOfYesterday } from "date-fns";
import { GENDER_LABELS, ROUTES } from "@/constants";

interface CastingListProps {
  castings: Casting[];
  onTriggerCasting: (casting: Casting) => void;
}

const CastingList: React.FC<CastingListProps> = ({
  castings,
  onTriggerCasting,
}) => {
  const isCastingActive = (endDate: Date) => isAfter(endDate, endOfYesterday());

  const [selectedGender, setSelectedGender] = useState<Gender>("ANY");
  const filteredCastings = castings.filter(
    (casting) =>
      (selectedGender === "ANY" ||
        casting.gender === selectedGender ||
        casting.gender === "ANY") &&
      isCastingActive(casting.endDate),
  );

  const handleGenderChange = (gender: Gender) => {
    setSelectedGender(gender);
  };

  return (
    <div className="castings">
      <div className="castings__filter-radio">
        <RadioButton
          onChange={(value) => handleGenderChange(value as Gender)}
          options={GENDER_LABELS}
          value={selectedGender}
          variant="primary"
        />
        <Button
          to={ROUTES.public.castingsNew}
          variant="secondary"
          actionTrackSufix="create-casting"
          motionScale="base"
        >
          Agregá un casting
        </Button>
      </div>
      <div className="castings__filter-select">
        <div className="castings__filter-gender-label">
          <p>Filtrar castings:</p>
        </div>
        <Select
          options={GENDER_LABELS}
          value={selectedGender}
          onChange={(value) => handleGenderChange(value as Gender)}
          variant="primary"
          className="castings__filter-gender-btn"
        />
        <Button
          to={ROUTES.public.castingsNew}
          variant="secondary"
          actionTrackSufix="create-casting"
          className="castings__add-casting-btn"
          motionScale="base"
        >
          Agregar nuevo casting a la lista
        </Button>
      </div>

      {filteredCastings.length > 0 ? (
        <div className="castings__container">
          {filteredCastings.map((casting) => (
            <CastingCard
              key={casting.id}
              casting={casting}
              onApply={() => onTriggerCasting(casting)}
            />
          ))}
        </div>
      ) : (
        <div className="castings__empty">
          No se encontraron castings que coincidan con tu búsqueda.
        </div>
      )}
    </div>
  );
};

export default CastingList;
